var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('div',{staticClass:"firstheading"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"secondheading"},[_vm._v(_vm._s(_vm.subtitle))]),_c('div',{staticClass:"tags"},[_vm._v("选择下面的标签(每次最多选填三个)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }